import { render, staticRenderFns } from "./ExpressManagement.vue?vue&type=template&id=31e543f0&scoped=true"
import script from "./ExpressManagement.vue?vue&type=script&lang=js"
export * from "./ExpressManagement.vue?vue&type=script&lang=js"
import style0 from "./ExpressManagement.vue?vue&type=style&index=0&id=31e543f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e543f0",
  null
  
)

export default component.exports